import styles from "./styles.module.css";
import { BannerContentProps } from "types/BannerContent.type";

export default function BannerContent({ children, style }: BannerContentProps) {
  return (
    <div className={`${styles["section-banner-content"]} ${style || ""}`}>
      {children}
    </div>
  );
}
